import { FC } from 'react'
import { Text, Icon, Image, Button } from '@/client/components'
import * as S from './styles'
import { ResultProps } from '../types'

export const SearchResult: FC<ResultProps> = ({
  heading,
  material_name,
  colour,
  finishing,
  size,
  varnish,
  cutting,
  temperature,
  adhesive,
  recycle,
  used,
  long_text,
  button_1,
  button_2
}) => (
  <S.ResultConatiner>
    <div>
      <Text size='xlg' weight='semiBlack' align='left' padding='0 0 0 1rem'>
        {heading}
      </Text>
    </div>

    <S.Box>
      <Text size='lg' weight='semiBlack' align='left'>
        P2301
      </Text>

      <S.LabelInfo>
        <S.InfoWrapper>
          <Text align='left'>NOCHE - CRIANZA 2020 Wine label</Text>

          <S.LabelInfo>
            <S.Sections>
              <Text align='left' color='weak' margin='0'>
                {material_name}
              </Text>
              <Text align='left'>{'Premium Matt White 90g'}</Text>
              <Text align='left' color='weak' margin='0'>
                {colour}
              </Text>
              <Text align='left'>{'CMYK'}</Text>
              <Text align='left' color='weak' margin='0'>
                {finishing}
              </Text>
              <Text align='left'>{'Hotfoil Gold (Matt), Digital Spot Varnish'}</Text>
            </S.Sections>
            <S.Sections>
              <Text align='left' color='weak' margin='0'>
                {size}
              </Text>
              <Text align='left'>120 x 120 mm</Text>
              <Text align='left' color='weak' margin='0'>
                {varnish}
              </Text>
              <Text align='left'>Protective varnish (Matt)</Text>
              <Text align='left' color='weak' margin='0'>
                {cutting}
              </Text>
              <Text align='left'>Die-cutting</Text>
            </S.Sections>
          </S.LabelInfo>
        </S.InfoWrapper>

        <S.MaterialInfoWrapper>
          <Text align='left' color='weak' margin='0'>
            {material_name}
          </Text>
          <Text align='left'>{'Premium Matt White 90g'}</Text>

          <S.MaterialInfo>
            <>
              <Text align='left' color='weak' margin='0'>
                {cutting}
              </Text>

              <S.IconWrapper className='dots-icon'>
                <Icon name='circle-filled' size='s3' />
                <Icon name='circle-filled' size='s3' />
                <Icon name='circle-unfilled' size='s3' />
              </S.IconWrapper>
              <S.Divider />
            </>

            <>
              <Text align='left' color='weak' margin='0'>
                {temperature}
              </Text>
              <S.IconWrapper className='temperature'>
                <Text margin='0'> 20 °C </Text>
                <Image src={`/icons/temperature.svg`} alt='temperature' width={50} height={20} />
                <Text margin='0'> 80 °C </Text>
              </S.IconWrapper>
              <S.Divider />
            </>

            <>
              <Text align='left' color='weak' margin='0'>
                {adhesive}
              </Text>
              <Text margin='0'>Permanent</Text>
              <S.Divider />
            </>

            <>
              <Text align='left' color='weak' margin='0'>
                {recycle}
              </Text>
              <S.IconWrapper className='recycle'>
                <Icon name='eco' />
                <Icon name='fsc' />
                <Text margin='0'>Certified - mixed source </Text>
              </S.IconWrapper>
              <S.Divider />
            </>

            <>
              <Text align='left' color='weak' margin='0'>
                {used}
              </Text>
              <Text margin='0'>
                Glass or plastic jars & containers Bottle labeling Paper boxes or bags Shipping labels for packaging
              </Text>
            </>
          </S.MaterialInfo>
        </S.MaterialInfoWrapper>
      </S.LabelInfo>

      <Text align='left' color='weak'>
        {long_text}
      </Text>
    </S.Box>
    <S.ButtonWrapper>
      <Button kind='white'>
        {button_1}
        <Icon name='artwork-pdf' />
      </Button>
      <Button kind='warning'>{button_2}</Button>
    </S.ButtonWrapper>
  </S.ResultConatiner>
)
